import React from 'react'
import Button from '@mui/material/Button'
import Fab from '@mui/material/Fab'
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)(() => ({
        textTransform: 'none',
        fontFamily:'inherit',
        fontWeight:'400',
        flexGrow:0,
    }))

const StyledFab = styled(Fab)(() => ({
    textTransform: 'none',
    fontFamily:'inherit',
    fontWeight:'400',
    boxShadow:"unset",
}))

export function ThemeButton({children,...props}) { 
    
    return (
        <StyledButton {...props}>
            {children}
        </StyledButton>
    )
}

export function ThemeFab({children,...props}) {

    return (
        <StyledFab {...props}>
            {children}
        </StyledFab>
    )

}